module.exports = __webpack_public_path__ + "static/img/134.d7a5342.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/phoneCloseCM/rjzz/134.jpg
// module id = BxCf
// module chunks = 0